let resData;
let idRegistrationSong;

export const updateReportItem = (id, data) => {
  resData = data;
  idRegistrationSong = id;
  const currentWeek = $('#reportForm [name=weeks]').val();

  if (currentWeek && currentWeek !== data.week) {
    deleteItem(idRegistrationSong);
  }

  updateUsageItem('postedVideos', __('Posted Videos'), __('Posted Video'));
  updateUsageItem('lyricUses', __('Lyric Uses'), __('Lyric Use'));
  updateUsageItem('masterUses', __('Master Uses'), __('Master Use'));

  updateInfoAndLabel('masterSource', resData.masterSource);
  updateBtnData();
}

export const reportItemExists = (idRegistrationSong) => {
  const btn = getBtnByRegistrationSongId(idRegistrationSong);

  return btn.length > 0;
}

const deleteItem = (idRegistrationSong) => {
  const btn = getBtnByRegistrationSongId(idRegistrationSong);
  const lastItem = btn.parent().parent().parent();

  lastItem.slideToggle(300, function () {
    $(this).parent().remove();

    if (!$('.panel-report .row-title').length) {
      $('.missing-titles-info').fadeIn();
    }
  });
}

const updateUsageItem = (field, labelPlural, labelSingular) => {
  const value = resData[field];
  const label = value > 1 ? labelPlural : labelSingular;

  updateInfoAndLabel(field, value, label);
}

const updateInfoAndLabel = (className, value, label = null) => {
  const btn = getBtnByRegistrationSongId(idRegistrationSong);
  
  const infoEl = btn.closest('.search-music').find(`.infoUsage.${className}`);
  if (value !== undefined && value !== null && (value > 0 || value.length)) {
    infoEl.find('.infoValue').html(value);

    if (label !== null) {
      infoEl.find('.infoLabel').html(label);
    }

    infoEl.fadeIn(150);
  } else {
    infoEl.fadeOut(150);
  }
}

const getBtnByRegistrationSongId = (idRegistrationSong) => {
  return $(`.edit-report[data-id-registration-song=${idRegistrationSong}]`);
}

const updateBtnData = () => {
  const btn = $(`.edit-report[data-id=${resData.id}]`);

  btn.data('posted-videos', resData.postedVideos);
  btn.data('lyric-uses', resData.lyricUses);
  btn.data('master-uses', resData.masterUses);
  btn.data('master-source', resData.masterSource);
}
